// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LockTwoToneSvg from "@ant-design/icons-svg/es/asn/LockTwoTone";
import AntdIcon from '../components/AntdIcon';

var LockTwoTone = function LockTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LockTwoToneSvg
  }));
};

LockTwoTone.displayName = 'LockTwoTone';
export default React.forwardRef(LockTwoTone);